import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#F8F6F3]">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
          <Link to="/">
            <img
              src="https://public.readdy.ai/ai/img_res/88306fd4-3a9b-4b4d-9819-fcd38e3bf0f2.png"
              alt="Lios S.r.l."
              className="h-6 w-auto"
            />
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm font-medium text-[#1A4D4D] hover:text-[#2D5F5F] transition-colors cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-left-line"></i>
            </span>
            Torna al sito
          </Link>
        </div>
      </header>

      {/* Hero */}
      <div className="bg-[#1A3D3D] text-white py-20">
        <div className="max-w-[900px] mx-auto px-6 lg:px-12">
          <p className="text-xs uppercase tracking-widest text-gray-400 mb-4 font-medium">Documento legale</p>
          <h1 className="text-4xl lg:text-5xl font-bold mb-4 leading-tight">Privacy Policy</h1>
          <p className="text-gray-300 font-light text-lg">
            Informativa sul trattamento dei dati personali ai sensi del Regolamento UE 2016/679 (GDPR)
          </p>
          <p className="text-gray-400 text-sm mt-6 font-light">
            Ultimo aggiornamento: 10 aprile 2026
          </p>
        </div>
      </div>

      {/* Content */}
      <main className="max-w-[900px] mx-auto px-6 lg:px-12 py-16">

        {/* Indice */}
        <div className="bg-white rounded-2xl p-8 mb-12 border border-gray-100">
          <h2 className="text-lg font-bold text-[#2C2C2C] mb-6 flex items-center gap-2">
            <span className="w-6 h-6 flex items-center justify-center">
              <i className="ri-list-check text-[#1A4D4D]"></i>
            </span>
            Indice
          </h2>
          <ol className="space-y-2 text-sm text-[#1A4D4D] font-medium">
            {[
              'Titolare del Trattamento',
              'Tipologie di Dati Raccolti',
              'Finalità e Base Giuridica del Trattamento',
              'Modalità del Trattamento',
              'Conservazione dei Dati',
              'Comunicazione e Diffusione dei Dati',
              'Trasferimento dei Dati all\'Estero',
              'Diritti dell\'Interessato',
              'Cookie Policy',
              'Modifiche alla Privacy Policy',
              'Contatti',
            ].map((item, i) => (
              <li key={i}>
                <a href={`#art-${i + 1}`} className="hover:text-[#FF6B35] transition-colors cursor-pointer">
                  {i + 1}. {item}
                </a>
              </li>
            ))}
          </ol>
        </div>

        {/* Articoli */}
        <div className="space-y-10">

          {/* Art. 1 */}
          <article id="art-1" className="bg-white rounded-2xl p-8 border border-gray-100">
            <h4 className="text-xl font-bold text-[#2C2C2C] mb-6 flex items-center gap-3">
              <span className="w-8 h-8 bg-[#1A4D4D] text-white rounded-full flex items-center justify-center text-sm font-bold shrink-0">1</span>
              <a href="#art-1">Titolare del Trattamento</a>
            </h4>
            <p className="text-gray-600 font-light leading-relaxed mb-4">
              Il Titolare del trattamento dei dati personali, ai sensi dell'art. 4 n. 7 del Regolamento UE 2016/679 (GDPR), è:
            </p>
            <div className="bg-[#F8F6F3] rounded-xl p-6 space-y-2 text-sm">
              <p><strong className="text-[#2C2C2C]">Ragione sociale:</strong> <span className="text-gray-600 font-light">Lios S.r.l.</span></p>
              <p><strong className="text-[#2C2C2C]">Sede legale:</strong> <span className="text-gray-600 font-light">Via Vittorio Emanuele III 159/161, 80027 Frattamaggiore (NA), Italia</span></p>
              <p><strong className="text-[#2C2C2C]">Partita IVA:</strong> <span className="text-gray-600 font-light">08771441212</span></p>
              <p><strong className="text-[#2C2C2C]">PEC:</strong> <span className="text-gray-600 font-light">liossrl@unapec.it</span></p>
              <p><strong className="text-[#2C2C2C]">Email:</strong> <span className="text-gray-600 font-light">commerciale.liosrl@gmail.com</span></p>
              <p><strong className="text-[#2C2C2C]">Telefono:</strong> <span className="text-gray-600 font-light">081 18810690</span></p>
              <p><strong className="text-[#2C2C2C]">Cellulare:</strong> <span className="text-gray-600 font-light">+39 351 426 5388</span></p>
            </div>
          </article>

          {/* Art. 2 */}
          <article id="art-2" className="bg-white rounded-2xl p-8 border border-gray-100">
            <h4 className="text-xl font-bold text-[#2C2C2C] mb-6 flex items-center gap-3">
              <span className="w-8 h-8 bg-[#1A4D4D] text-white rounded-full flex items-center justify-center text-sm font-bold shrink-0">2</span>
              <a href="#art-2">Tipologie di Dati Raccolti</a>
            </h4>
            <p className="text-gray-600 font-light leading-relaxed mb-4">
              Il Titolare raccoglie le seguenti categorie di dati personali:
            </p>
            <div className="space-y-4">
              <div className="border-l-4 border-[#1A4D4D] pl-4">
                <p className="font-semibold text-[#2C2C2C] text-sm mb-1">Dati di contatto</p>
                <p className="text-gray-600 font-light text-sm leading-relaxed">Nome, cognome, indirizzo email, numero di telefono, nome dell'azienda, forniti volontariamente dall'utente tramite il modulo di contatto o la newsletter.</p>
              </div>
              <div className="border-l-4 border-[#FF6B35] pl-4">
                <p className="font-semibold text-[#2C2C2C] text-sm mb-1">Dati di navigazione</p>
                <p className="text-gray-600 font-light text-sm leading-relaxed">Indirizzo IP, tipo di browser, sistema operativo, pagine visitate, orario di accesso, raccolti automaticamente dai sistemi informatici del sito.</p>
              </div>
              <div className="border-l-4 border-gray-300 pl-4">
                <p className="font-semibold text-[#2C2C2C] text-sm mb-1">Dati forniti volontariamente</p>
                <p className="text-gray-600 font-light text-sm leading-relaxed">Qualsiasi informazione aggiuntiva che l'utente sceglie di condividere attraverso i moduli presenti sul sito o via email.</p>
              </div>
            </div>
          </article>

          {/* Art. 3 */}
          <article id="art-3" className="bg-white rounded-2xl p-8 border border-gray-100">
            <h4 className="text-xl font-bold text-[#2C2C2C] mb-6 flex items-center gap-3">
              <span className="w-8 h-8 bg-[#1A4D4D] text-white rounded-full flex items-center justify-center text-sm font-bold shrink-0">3</span>
              <a href="#art-3">Finalità e Base Giuridica del Trattamento</a>
            </h4>
            <div className="space-y-4">
              {[
                {
                  finalita: 'Risposta alle richieste di contatto',
                  base: 'Esecuzione di misure precontrattuali (art. 6, par. 1, lett. b GDPR)',
                  desc: 'Elaborazione delle richieste inviate tramite il modulo di contatto per fornire preventivi e informazioni sui servizi.'
                },
                {
                  finalita: 'Invio newsletter',
                  base: 'Consenso dell\'interessato (art. 6, par. 1, lett. a GDPR)',
                  desc: 'Invio di comunicazioni commerciali, aggiornamenti e novità sui servizi Lios S.r.l., previa iscrizione volontaria.'
                },
                {
                  finalita: 'Adempimenti legali e fiscali',
                  base: 'Obbligo legale (art. 6, par. 1, lett. c GDPR)',
                  desc: 'Conservazione dei dati necessari per adempiere agli obblighi di legge, fiscali e contabili.'
                },
                {
                  finalita: 'Sicurezza del sito',
                  base: 'Legittimo interesse (art. 6, par. 1, lett. f GDPR)',
                  desc: 'Monitoraggio e protezione del sito web da accessi non autorizzati, attacchi informatici e abusi.'
                },
              ].map((item, i) => (
                <div key={i} className="bg-[#F8F6F3] rounded-xl p-5">
                  <p className="font-semibold text-[#2C2C2C] text-sm mb-1">{item.finalita}</p>
                  <p className="text-[#1A4D4D] text-xs font-medium mb-2">{item.base}</p>
                  <p className="text-gray-600 font-light text-sm leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </article>

          {/* Art. 4 */}
          <article id="art-4" className="bg-white rounded-2xl p-8 border border-gray-100">
            <h4 className="text-xl font-bold text-[#2C2C2C] mb-6 flex items-center gap-3">
              <span className="w-8 h-8 bg-[#1A4D4D] text-white rounded-full flex items-center justify-center text-sm font-bold shrink-0">4</span>
              <a href="#art-4">Modalità del Trattamento</a>
            </h4>
            <p className="text-gray-600 font-light leading-relaxed mb-4">
              I dati personali sono trattati con strumenti automatizzati e manuali, nel rispetto delle misure di sicurezza tecniche e organizzative previste dall'art. 32 del GDPR, al fine di garantire un livello di sicurezza adeguato al rischio.
            </p>
            <p className="text-gray-600 font-light leading-relaxed">
              Il trattamento è effettuato esclusivamente da personale autorizzato e debitamente istruito da Lios S.r.l., oppure da eventuali responsabili del trattamento nominati ai sensi dell'art. 28 del GDPR.
            </p>
          </article>

          {/* Art. 5 */}
          <article id="art-5" className="bg-white rounded-2xl p-8 border border-gray-100">
            <h4 className="text-xl font-bold text-[#2C2C2C] mb-6 flex items-center gap-3">
              <span className="w-8 h-8 bg-[#1A4D4D] text-white rounded-full flex items-center justify-center text-sm font-bold shrink-0">5</span>
              <a href="#art-5">Conservazione dei Dati</a>
            </h4>
            <p className="text-gray-600 font-light leading-relaxed mb-4">
              I dati personali sono conservati per il tempo strettamente necessario al conseguimento delle finalità per cui sono stati raccolti:
            </p>
            <ul className="space-y-3">
              {[
                { tipo: 'Dati del modulo di contatto', periodo: '24 mesi dalla ricezione della richiesta' },
                { tipo: 'Dati newsletter', periodo: 'Fino alla revoca del consenso da parte dell\'interessato' },
                { tipo: 'Dati fiscali e contabili', periodo: '10 anni ai sensi della normativa fiscale italiana' },
                { tipo: 'Dati di navigazione', periodo: '12 mesi dalla raccolta' },
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-3 text-sm">
                  <span className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                    <i className="ri-time-line text-[#1A4D4D]"></i>
                  </span>
                  <span>
                    <strong className="text-[#2C2C2C]">{item.tipo}:</strong>{' '}
                    <span className="text-gray-600 font-light">{item.periodo}</span>
                  </span>
                </li>
              ))}
            </ul>
          </article>

          {/* Art. 6 */}
          <article id="art-6" className="bg-white rounded-2xl p-8 border border-gray-100">
            <h4 className="text-xl font-bold text-[#2C2C2C] mb-6 flex items-center gap-3">
              <span className="w-8 h-8 bg-[#1A4D4D] text-white rounded-full flex items-center justify-center text-sm font-bold shrink-0">6</span>
              <a href="#art-6">Comunicazione e Diffusione dei Dati</a>
            </h4>
            <p className="text-gray-600 font-light leading-relaxed mb-4">
              I dati personali non sono diffusi a terzi, né ceduti a scopo commerciale. Possono essere comunicati esclusivamente a:
            </p>
            <ul className="space-y-3">
              {[
                'Soggetti che forniscono servizi tecnici e informatici necessari al funzionamento del sito (es. hosting provider)',
                'Professionisti e consulenti di Lios S.r.l. per adempimenti legali, fiscali e contabili',
                'Autorità giudiziarie o amministrative, nei casi previsti dalla legge',
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-3 text-sm text-gray-600 font-light">
                  <span className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                    <i className="ri-checkbox-circle-line text-[#1A4D4D]"></i>
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </article>

          {/* Art. 7 */}
          <article id="art-7" className="bg-white rounded-2xl p-8 border border-gray-100">
            <h4 className="text-xl font-bold text-[#2C2C2C] mb-6 flex items-center gap-3">
              <span className="w-8 h-8 bg-[#1A4D4D] text-white rounded-full flex items-center justify-center text-sm font-bold shrink-0">7</span>
              <a href="#art-7">Trasferimento dei Dati all'Estero</a>
            </h4>
            <p className="text-gray-600 font-light leading-relaxed">
              I dati personali sono trattati prevalentemente all'interno del territorio dell'Unione Europea. Qualora si rendesse necessario un trasferimento verso Paesi terzi, tale trasferimento avverrà nel rispetto delle garanzie previste dagli artt. 44-49 del GDPR, incluse le clausole contrattuali standard approvate dalla Commissione Europea.
            </p>
          </article>

          {/* Art. 8 */}
          <article id="art-8" className="bg-white rounded-2xl p-8 border border-gray-100">
            <h4 className="text-xl font-bold text-[#2C2C2C] mb-6 flex items-center gap-3">
              <span className="w-8 h-8 bg-[#1A4D4D] text-white rounded-full flex items-center justify-center text-sm font-bold shrink-0">8</span>
              <a href="#art-8">Diritti dell'Interessato</a>
            </h4>
            <p className="text-gray-600 font-light leading-relaxed mb-6">
              Ai sensi degli artt. 15-22 del GDPR, l'interessato ha il diritto di:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {[
                { icon: 'ri-eye-line', titolo: 'Accesso', desc: 'Ottenere conferma del trattamento e accedere ai propri dati personali' },
                { icon: 'ri-edit-line', titolo: 'Rettifica', desc: 'Richiedere la correzione di dati inesatti o incompleti' },
                { icon: 'ri-delete-bin-line', titolo: 'Cancellazione', desc: 'Richiedere la cancellazione dei dati ("diritto all\'oblio")' },
                { icon: 'ri-pause-circle-line', titolo: 'Limitazione', desc: 'Richiedere la limitazione del trattamento in determinati casi' },
                { icon: 'ri-download-cloud-line', titolo: 'Portabilità', desc: 'Ricevere i propri dati in formato strutturato e leggibile' },
                { icon: 'ri-close-circle-line', titolo: 'Opposizione', desc: 'Opporsi al trattamento basato su legittimo interesse' },
                { icon: 'ri-shield-check-line', titolo: 'Revoca consenso', desc: 'Revocare il consenso in qualsiasi momento senza pregiudizio' },
                { icon: 'ri-government-line', titolo: 'Reclamo', desc: 'Proporre reclamo al Garante per la Protezione dei Dati Personali' },
              ].map((item, i) => (
                <div key={i} className="bg-[#F8F6F3] rounded-xl p-4 flex items-start gap-3">
                  <span className="w-8 h-8 flex items-center justify-center bg-[#1A4D4D]/10 rounded-lg shrink-0">
                    <i className={`${item.icon} text-[#1A4D4D] text-sm`}></i>
                  </span>
                  <div>
                    <p className="font-semibold text-[#2C2C2C] text-sm">{item.titolo}</p>
                    <p className="text-gray-600 font-light text-xs leading-relaxed mt-0.5">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-6 bg-[#1A4D4D]/5 border border-[#1A4D4D]/20 rounded-xl p-5">
              <p className="text-sm text-gray-600 font-light leading-relaxed">
                Per esercitare i propri diritti, l'interessato può contattare il Titolare del trattamento all'indirizzo email{' '}
                <a href="mailto:commerciale.liosrl@gmail.com" className="text-[#1A4D4D] font-medium hover:underline">
                  commerciale.liosrl@gmail.com
                </a>{' '}
                oppure tramite PEC all'indirizzo{' '}
                <a href="mailto:liossrl@unapec.it" className="text-[#1A4D4D] font-medium hover:underline">
                  liossrl@unapec.it
                </a>.
                Il Titolare risponderà entro 30 giorni dalla ricezione della richiesta.
              </p>
            </div>
          </article>

          {/* Art. 9 */}
          <article id="art-9" className="bg-white rounded-2xl p-8 border border-gray-100">
            <h4 className="text-xl font-bold text-[#2C2C2C] mb-6 flex items-center gap-3">
              <span className="w-8 h-8 bg-[#1A4D4D] text-white rounded-full flex items-center justify-center text-sm font-bold shrink-0">9</span>
              <a href="#art-9">Cookie Policy</a>
            </h4>
            <p className="text-gray-600 font-light leading-relaxed mb-4">
              Il sito utilizza cookie tecnici necessari al corretto funzionamento delle pagine. Non vengono utilizzati cookie di profilazione o di tracciamento di terze parti senza il previo consenso dell'utente.
            </p>
            <div className="space-y-3">
              {[
                { tipo: 'Cookie tecnici', desc: 'Necessari per il funzionamento del sito. Non richiedono consenso.', consenso: false },
                { tipo: 'Cookie analitici', desc: 'Utilizzati per analisi statistiche anonime del traffico sul sito.', consenso: true },
                { tipo: 'Cookie di terze parti', desc: 'Eventualmente presenti per mappe integrate (Google Maps).', consenso: true },
              ].map((item, i) => (
                <div key={i} className="flex items-start gap-3 p-4 bg-[#F8F6F3] rounded-xl text-sm">
                  <span className={`w-5 h-5 flex items-center justify-center mt-0.5 shrink-0 ${item.consenso ? 'text-amber-500' : 'text-green-600'}`}>
                    <i className={item.consenso ? 'ri-information-line' : 'ri-checkbox-circle-line'}></i>
                  </span>
                  <div>
                    <p className="font-semibold text-[#2C2C2C]">{item.tipo}</p>
                    <p className="text-gray-600 font-light mt-0.5">{item.desc}</p>
                    <p className={`text-xs mt-1 font-medium ${item.consenso ? 'text-amber-600' : 'text-green-600'}`}>
                      {item.consenso ? 'Richiede consenso' : 'Non richiede consenso'}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </article>

          {/* Art. 10 */}
          <article id="art-10" className="bg-white rounded-2xl p-8 border border-gray-100">
            <h4 className="text-xl font-bold text-[#2C2C2C] mb-6 flex items-center gap-3">
              <span className="w-8 h-8 bg-[#1A4D4D] text-white rounded-full flex items-center justify-center text-sm font-bold shrink-0">10</span>
              <a href="#art-10">Modifiche alla Privacy Policy</a>
            </h4>
            <p className="text-gray-600 font-light leading-relaxed">
              Lios S.r.l. si riserva il diritto di modificare la presente informativa in qualsiasi momento, dandone comunicazione agli utenti su questa pagina. Si invita pertanto a consultare periodicamente questa pagina, prendendo come riferimento la data di ultima modifica indicata in cima al documento.
            </p>
          </article>

          {/* Art. 11 */}
          <article id="art-11" className="bg-white rounded-2xl p-8 border border-gray-100">
            <h4 className="text-xl font-bold text-[#2C2C2C] mb-6 flex items-center gap-3">
              <span className="w-8 h-8 bg-[#1A4D4D] text-white rounded-full flex items-center justify-center text-sm font-bold shrink-0">11</span>
              <a href="#art-11">Contatti</a>
            </h4>
            <p className="text-gray-600 font-light leading-relaxed mb-6">
              Per qualsiasi informazione relativa al trattamento dei dati personali o per esercitare i propri diritti, è possibile contattare Lios S.r.l. ai seguenti recapiti:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {[
                { icon: 'ri-map-pin-line', label: 'Sede legale', value: 'Via Vittorio Emanuele III 159/161\n80027 Frattamaggiore (NA)' },
                { icon: 'ri-mail-line', label: 'Email', value: 'commerciale.liosrl@gmail.com' },
                { icon: 'ri-mail-send-line', label: 'PEC', value: 'liossrl@unapec.it' },
                { icon: 'ri-phone-line', label: 'Telefono', value: '081 18810690\n+39 351 426 5388' },
              ].map((item, i) => (
                <div key={i} className="flex items-start gap-3 p-4 bg-[#F8F6F3] rounded-xl">
                  <span className="w-8 h-8 flex items-center justify-center bg-[#1A4D4D]/10 rounded-lg shrink-0">
                    <i className={`${item.icon} text-[#1A4D4D] text-sm`}></i>
                  </span>
                  <div>
                    <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">{item.label}</p>
                    <p className="text-sm text-[#2C2C2C] font-medium whitespace-pre-line">{item.value}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-6 p-5 bg-[#F8F6F3] rounded-xl">
              <p className="text-sm text-gray-600 font-light leading-relaxed">
                <strong className="text-[#2C2C2C]">Garante per la Protezione dei Dati Personali:</strong>{' '}
                È possibile proporre reclamo all'Autorità di controllo italiana visitando il sito{' '}
                <a href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer" className="text-[#1A4D4D] font-medium hover:underline">
                  www.garanteprivacy.it
                </a>
              </p>
            </div>
          </article>

        </div>

        {/* Back to top */}
        <div className="mt-12 text-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-[#1A4D4D] text-white px-8 py-4 rounded-full font-medium hover:bg-[#2D5F5F] transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-left-line"></i>
            </span>
            Torna al sito
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#1A3D3D] text-white mt-16">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
            <p className="font-light">© 2026 Lios S.r.l. - P.IVA 08771441212 - Tutti i diritti riservati</p>
            <Link to="/" className="hover:text-[#FF6B35] transition-colors cursor-pointer font-light">
              Torna alla Home
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
